import { render, staticRenderFns } from "./appraisal.vue?vue&type=template&id=54ab1e1b&"
import script from "./appraisal.vue?vue&type=script&lang=js&"
export * from "./appraisal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports